import { getSport8Studio } from '../../../api/sport8Api'
import { getSearchParams } from '../../../helpers/utils'
import translate from '../../../i18n'
import { Sport8StudioDto } from '../share-type'
import { SearchOutlined } from '@ant-design/icons'
import { Button, Descriptions, Form, Image, Input, notification, Space } from 'antd'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

const Sport8Studio = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [studio, setStudio] = useState<Sport8StudioDto | undefined>()
  const [searchForm] = Form.useForm()

  useEffect(() => {
    const name = searchParams.get('name')
    const studioId = searchParams.get('studioId')

    if (name || studioId) {
      searchForm.setFieldValue('name', name)
      searchForm.setFieldValue('studioId', studioId)
      fetchSport8StudioAction({ name, studioId })
    }
  }, [searchParams])

  const onSearch = (values: { name: string | null; studioId: string | null }) => {
    setSearchParams(getSearchParams(values))
  }

  const fetchSport8StudioAction = (values: { name: string | null; studioId: string | null }) => {
    getSport8Studio(values.name, values.studioId)
      .then((res: Sport8StudioDto) => {
        if (res) {
          setStudio(res)
        }
      })
      .catch(err => {
        notification.error({
          message: '获取韵动吧场馆失败',
          description: err?.message || translate('networkError'),
        })
      })
  }

  return (
    <Space className="table-space" orientation="vertical" size={16}>
      <div className="filter-bar">
        <Form form={searchForm} layout="inline" style={{ gap: '16px' }} onFinish={onSearch}>
          <Form.Item name="studioId" label={translate('studio.studioId')}>
            <Input />
          </Form.Item>
          <Form.Item name="name" label={translate('name')}>
            <Input />
          </Form.Item>
          <Form.Item>
            <Button htmlType="submit" type="primary" icon={<SearchOutlined />}>
              {translate('search')}
            </Button>
          </Form.Item>
        </Form>
      </div>
      {studio && (
        <Space orientation="vertical" size={16}>
          <Descriptions
            styles={{
              label: { alignItems: 'center', fontWeight: 600, width: '200px' },
              content: { minWidth: 500 },
            }}
            column={2}
            bordered
          >
            <Descriptions.Item label="ID">{studio.id}</Descriptions.Item>
            <Descriptions.Item label={translate('name')}>{studio.name}</Descriptions.Item>
            <Descriptions.Item label={translate('studio.phoneNumber')} span={2}>
              {studio.phone}
            </Descriptions.Item>
            <Descriptions.Item label="Introduce" span={2}>
              {studio.introduce}
            </Descriptions.Item>
            <Descriptions.Item label={translate('studio.longitude')}>
              {studio.longitude}
            </Descriptions.Item>
            <Descriptions.Item label={translate('studio.latitude')}>
              {studio.latitude}
            </Descriptions.Item>
            <Descriptions.Item label={translate('studioTranslation.address1')} span={2}>
              {studio.address}
            </Descriptions.Item>
            <Descriptions.Item label={translate('photos')} span={2}>
              <Image src={studio.photoUrl} style={{ maxHeight: '200px' }} />
            </Descriptions.Item>
          </Descriptions>
          {studio.stadiumphotos.map(stadium => (
            <Descriptions
              key={stadium.photoId}
              styles={{
                label: { alignItems: 'center', fontWeight: 600, width: '200px' },
                content: { minWidth: 500 },
              }}
              column={2}
              bordered
            >
              <Descriptions.Item label="Photo Id">{stadium.photoId}</Descriptions.Item>
              <Descriptions.Item label="Type">{stadium.type}</Descriptions.Item>
              <Descriptions.Item label="Target Id">{stadium.targetId}</Descriptions.Item>
              <Descriptions.Item label="Target Type">{stadium.targetType}</Descriptions.Item>
              <Descriptions.Item label="Src Image">
                <Image src={stadium.srcPath} style={{ maxHeight: '200px' }} />
              </Descriptions.Item>
              <Descriptions.Item label="Get Image">
                <Image src={stadium.getPath} style={{ maxHeight: '200px' }} />
              </Descriptions.Item>
            </Descriptions>
          ))}
        </Space>
      )}
    </Space>
  )
}

export default Sport8Studio
